import SvgIcon from 'components/Globals/Base/SvgIcon';
import useBreakpoint from 'hooks/useBreakpoint';
import Link from 'components/Globals/Base/Link';
import NEWSLETTERS_SECTION_TEST_IDS from 'constants/testsIds/newslettersPage';
import * as S from './NewsletterCardStyles';

export interface NewsletterCardProps {
  authors: string;
  title: string;
  description: string;
  sampleUrl: string;
  frequencyOfPublication: string;
  onClick: () => void;
  subscriptionStatus: 'subscribed' | 'unsubscribed' | 'recently-unsubscribed';
  className?: string;
}

const NewsletterCard = ({
  authors,
  title,
  description,
  sampleUrl,
  frequencyOfPublication,
  subscriptionStatus,
  onClick,
  className,
}: NewsletterCardProps) => {
  const isMobile = useBreakpoint('mdMax');

  return (
    <S.CardWrapper data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_WRAPPER}>
      <S.TopSectionWrapper className={className}>
        {subscriptionStatus === 'subscribed' && (
          <SvgIcon
            data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_ICON}
            name='CheckMarkFull'
            className='checkmark'
          />
        )}
        {!isMobile && <S.CardLine />}
        <S.TitleWrapper>
          <div>
            <S.NewsletterFrequency data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_FREQUENCY}>
              {frequencyOfPublication}
            </S.NewsletterFrequency>
            <S.CardTitle data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_TITLE}>{title}</S.CardTitle>
          </div>
          <S.AuthorsLine data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_AUTHORS_LINE}>
            BY <S.Authors data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_AUTHORS}>{authors}</S.Authors>
          </S.AuthorsLine>
        </S.TitleWrapper>
      </S.TopSectionWrapper>
      <S.BottomSection>
        <S.CardDescription>
          <p data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_DESCRIPTION}>{description}</p>
        </S.CardDescription>
        <S.SubscribeSection
          data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_SUBSCRIBE_SECTION}
          hasSampleUrl={sampleUrl ? true : false}
        >
          {sampleUrl ? (
            <Link
              data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_SUBSCRIBE_SECTION_LINK}
              className='link'
              type='tertiaryButton'
              target='_blank'
              href={sampleUrl}
              size={{ default: 'small', mdMin: 'small' }}
            >
              View Sample
            </Link>
          ) : null}
          <button
            data-cy={NEWSLETTERS_SECTION_TEST_IDS.NEWSLETTER_CARD_SUBSCRIBE_SECTION_BUTTON}
            type='button'
            className='sub-button'
            aria-label={subscriptionStatus === 'subscribed' ? 'Unsubscribe' : 'Subscribe'}
            onClick={onClick}
          >
            {subscriptionStatus !== 'subscribed' ? <SvgIcon name='PlusCircle' /> : <SvgIcon name='MinusCircle' />}
          </button>
        </S.SubscribeSection>
      </S.BottomSection>
    </S.CardWrapper>
  );
};

export default NewsletterCard;
